import React from "react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import { ratnadip, monika, rajesh } from "../../assets/images";
import { FaFacebook, FaLinkedin } from "react-icons/fa";
import { Helmet } from "react-helmet";

const About = () => {
  let iconLinkdinStyles = { color: "#0a66c2", fontSize: "1.4em" };
  let iconFbStyles = { color: "#0866FF", fontSize: "1.4em" };

  return (
    <div className="max-w-container mx-auto px-4">
      <Helmet>
        <title>About Us | RK Global Trader - Trusted Indian Exporter</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="RK Global Trader is a certified Indian export company offering agricultural products, processed foods, spices, cereals, and global trading services. Learn about our mission, vision, and professional export team."
        />
        <meta
          name="keywords"
          content="Indian exporter, RK Global Trader, agricultural export India, spices exporter India, global import export company, certified exporter, international trade India, export business, import export services, food export company"
        />
        <meta name="author" content="RK Global Trader - Exporter from India" />
        <link rel="canonical" href="https://www.rkglobaltrader.com/about" />
        <meta property="og:title" content="About RK Global Trader - Certified Exporter from India" />
        <meta
          property="og:description"
          content="Learn about RK Global Trader's global export operations, mission, team, and commitment to quality international trade."
        />
        <meta property="og:url" content="https://www.rkglobaltrader.com/about" />
        <meta property="og:type" content="website" />
      </Helmet>

      <Breadcrumbs title="About" />

      <div className="pb-10">
        <div className="pl-11 pr-11 mb-4">
          <span className="text-primeColor font-semibold text-lg">About RK Global Trader</span>

          {/* Company Profile PDF */}
          <p className="company-profile-link my-5">
            <a
              href="/company-profile-rk-global-trader.pdf"
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              📄 Download RK Global Trader Company Profile – India’s trusted exporter of fresh fruits, vegetables, and agro products.
            </a>
          </p>

          <h1 className="text-base text-lightText text-justify mb-2 mt-2">
            RK Global Trader is a leading Indian export company specializing in agricultural commodities, food products, spices, and global trading solutions. With a strong network across international markets, we are committed to delivering high-quality export services with complete transparency and professionalism.
            <br />
            <p className="mt-2">
              India is one of the world's largest exporters, and at RK Global Trader, we contribute by offering premium agricultural products, engineering items, processed foods, and more. Our export-import services are built to support international buyers with reliability and efficiency.
            </p>
          </h1>
        </div>

        <div className="pl-11 pr-11 mb-4">
          <span className="text-primeColor font-semibold text-lg">Our Team</span>
          <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10 mdl:gap-4 lg:gap-10">
            <div className="border-[1px] pt-2 px-4 text-center">
              <img src={ratnadip} alt="Ratnadip Kokate - Sales Operations" className="m-auto w-4/5" />
              <div className="pt-3 text-base font-semibold">Mr. Ratnadip Kokate</div>
              <div className="text-xs">Sales Operations</div>
              <ul className="mt-4">
                <li className="list-disc text-sm">Founder - RK Global Trader (Nov 2023)</li>
              </ul>
              <div className="text-base mt-2">Email: sales@rkglobaltrader.com</div>
              <div className="text-base mt-1">
                <a href="https://www.linkedin.com/in/ratnadipkokate/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1">LinkedIn <FaLinkedin style={iconLinkdinStyles} /></a>
                <br />
                <a href="https://www.facebook.com/KokateRatnadip" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 mt-1">Facebook <FaFacebook style={iconFbStyles} /></a>
              </div>
            </div>

            <div className="border-[1px] pt-2 px-4 text-center">
              <img src={monika} alt="Dr. Monika Kokate - Sales Operations" className="m-auto w-4/5" />
              <div className="pt-3 text-base font-semibold">Dr. Monika Kokate</div>
              <div className="text-xs">Sales Operations</div>
              <ul className="mt-4">
                <li className="list-disc text-sm">Co-Founder - RK Global Trader (Nov 2023)</li>
              </ul>
              <div className="text-base mt-2">Email: pathare.monika@gmail.com</div>
              <div className="text-base mt-1">
                <a href="https://www.linkedin.com/in/monika-pathre-5a999823b/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1">LinkedIn <FaLinkedin style={iconLinkdinStyles} /></a>
                <br />
                <a href="https://www.facebook.com/monika.pathare.7" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 mt-1">Facebook <FaFacebook style={iconFbStyles} /></a>
              </div>
            </div>

            <div className="border-[1px] pt-2 px-4 text-center">
              <img src={rajesh} alt="Rajesh Hande - CHA Docks Clerk" className="m-auto w-4/5" />
              <div className="pt-3 text-base font-semibold">Mr. Rajesh Hande</div>
              <div className="text-xs">CHA - Docks Clerk</div>
              <ul className="mt-4">
                <li className="list-disc text-sm">Joined RK Global Trader in Dec 2023</li>
              </ul>
              <div className="text-base mt-2">Email: rajeshhandeov@gmail.com</div>
              <div className="text-base mt-1">
                <a href="https://www.facebook.com/rajbhau2234" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1">Facebook <FaFacebook style={iconFbStyles} /></a>
              </div>
            </div>
          </div>
        </div>

        <div className="pl-11 pr-11 mb-4">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-10">
            <div className="border-[1px] pt-2 px-4">
              <span className="text-primeColor font-semibold text-lg">Our Journey</span>
              <h1 className="text-base text-lightText text-justify mt-2">
                Established in December 2023, RK Global Trader has rapidly grown into a trusted international export company. Our journey started with the goal of simplifying global trade and supporting businesses in expanding their global reach.
              </h1>
            </div>

            <div className="border-[1px] pt-2 px-4">
              <span className="text-primeColor font-semibold text-lg">Our Vision</span>
              <h1 className="text-base text-lightText text-justify mt-2">
                To build seamless trade pathways that connect India with global markets. Our vision is to empower businesses with access to new opportunities through ethical, efficient, and sustainable export services.
              </h1>
            </div>

            <div className="border-[1px] pt-2 px-4">
              <span className="text-primeColor font-semibold text-lg">Who We Are</span>
              <h1 className="text-base text-lightText text-justify mt-2">
                RK Global Trader is your strategic partner for global trading. We deliver reliable export and import services backed by expertise, transparency, and dedication to excellence.
              </h1>
            </div>

            <div className="border-[1px] pt-2 px-4">
              <span className="text-primeColor font-semibold text-lg">Our Mission</span>
              <h1 className="text-base text-lightText text-justify mt-2">
                Our mission is to simplify international trade by providing tailored, efficient, and result-oriented export-import solutions to global businesses.
              </h1>
            </div>
          </div>
        </div>

        <div className="pl-11 pr-11 mb-4">
          <span className="text-primeColor font-semibold text-lg">What Sets Us Apart</span>
          <ul className="mt-2">
            <li className="pt-2">
              <span className="text-primeColor font-semibold text-lg">Global Network:</span>
              <h1 className="text-base text-lightText text-justify">Our strong international partnerships enable us to offer reliable and large-scale export-import solutions across multiple countries.</h1>
            </li>
            <li className="pt-2">
              <span className="text-primeColor font-semibold text-lg">Expertise:</span>
              <h1 className="text-base text-lightText text-justify">Our team brings expert knowledge in logistics, compliance, export documentation, and global market trends.</h1>
            </li>
            <li className="pt-2">
              <span className="text-primeColor font-semibold text-lg">Innovation:</span>
              <h1 className="text-base text-lightText text-justify">We adopt modern tools and technologies to deliver accurate, fast, and seamless export solutions.</h1>
            </li>
          </ul>
        </div>

        <div className="pl-11 pr-11 mb-4">
          <span className="text-primeColor font-semibold text-lg">Core Values</span>
          <ul className="mt-2">
            <li className="pt-2">
              <span className="text-primeColor font-semibold text-lg">Integrity:</span>
              <h1 className="text-base text-lightText text-justify">Honesty, transparency, and ethics guide every decision we make.</h1>
            </li>
            <li className="pt-2">
              <span className="text-primeColor font-semibold text-lg">Customer-Centric:</span>
              <h1 className="text-base text-lightText text-justify">Our clients are our priority. We provide tailored export solutions based on their unique business needs.</h1>
            </li>
            <li className="pt-2">
              <span className="text-primeColor font-semibold text-lg">Continuous Improvement:</span>
              <h1 className="text-base text-lightText text-justify">We continuously improve our services to adapt to the ever-changing global business environment.</h1>
            </li>
          </ul>
        </div>

        <div className="pl-11 pr-11 pt-1 mb-4">
          <span className="text-primeColor font-semibold text-lg">Get in Touch</span>
          <h1 className="text-base text-lightText text-justify mt-2">Ready to explore new horizons with RK Global Trader? Contact us today to discover how our expertise, global network, and commitment to excellence can elevate your international export and import experience.</h1>
          <h1 className="text-base text-lightText text-justify mt-2">Thank you for choosing RK Global Trader — Where Global Opportunities Await!</h1>
        </div>
      </div>
    </div>
  );
};

export default About;
